import { IConfig } from '@cian/config/shared';

const NEWBUILDING_CONSULTANTS_PATH_CONFIG_KEY = 'newbuilding-consultants.pathUrl';

export const getNewbuildingSelectionsUrl = (config: IConfig): string => {
  return config.getStrict<string>(NEWBUILDING_CONSULTANTS_PATH_CONFIG_KEY);
};
